import { useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';

import { ONE_DAY_MILLI_SEC } from 'commons-ui';
import { DepositsFilters } from './constants';
import useService from './useService';

const useUserDeposits = () => {
	const { getUserDeposits } = useService();
	const [userDepositsData, setUserDepositsData] = useState<any>({ data: [], rowCount: 0 });
	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const [filters, setFilters] = useState<DepositsFilters>();
	const [showLoader, setShowLoader] = useState<boolean>(false);

	const fetchUserDepositsData = async () => {
		try {
			setShowLoader(true);
			const result = await getUserDeposits(filters);

			setUserDepositsData({ data: result?.data, rowCount: result?.rowCount });
			setForceUpdate(true);
		} catch (error: any) {
			setUserDepositsData({ data: [], rowCount: 0 });
			setForceUpdate(true);
		} finally {
			setShowLoader(false);
		}
	};

	useEffect(() => {
		if (filters) {
			fetchUserDepositsData();
		}
	}, [filters]);

	const getUserDepositsData = () => {
		setForceUpdate(false);
		return userDepositsData;
	};

	const handleFilterSubmit = (submittedFilters: { fromToDate?: Date[]; orderId?: string }) => {
		const { fromToDate, orderId } = submittedFilters;

		if (fromToDate && fromToDate.length === 2) {
			setFilters({ fromToDate: [fromToDate[0].getTime(), fromToDate[1].getTime() + ONE_DAY_MILLI_SEC] });
		} else if (!isEmpty(orderId)) {
			setFilters({ orderId });
		}
	};

	return { getUserDepositsData, handleFilterSubmit, forceUpdate, showLoader };
};

export default useUserDeposits;
